var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fffaa6c6dd910ba522b661a2405c067ac75eb7ee"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["denham-site@ask-phill"]={id:"fffaa6c6dd910ba522b661a2405c067ac75eb7ee"};
      